import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
    message?: string;
    className?: string;
}

export const LoadingState = ({
    message,
    className = 'h-64',
}: LoadingStateProps) => {
    const { t } = useTranslation('topupsModule');
    const displayMessage = message || t('loading.topups');

    return (
        <div className={'flex items-center justify-center ' + className}>
            <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
                <p className="text-gray-600">{displayMessage}</p>
            </div>
        </div>
    );
};

